module.exports = __webpack_public_path__ + "i18n/ru_3407a36db2e8fd0be0f83e6b1f59200f.json";


//////////////////
// WEBPACK FOOTER
// ./app/assets/i18n/m_ru.properties
// module id = flzm
// module chunks = 118